export const Customer = ({ customer, doReturn }) => {
  return (
    <div>
      Show data for customer {customer.id}:
      <p>{JSON.stringify(customer, undefined, "   ")}</p>
      <button onClick={doReturn}>Return</button>
    </div>
  );
};
